"use client";

import { motion } from "framer-motion";
import { MapPin, ShieldCheck } from "lucide-react";

interface Member {
  name: string;
  role: string;
  bio: string;
  badge?: string;
}

const TEAM: Member[] = [
  {
    name: "Mauro Cipriano",
    role: "CEO & Co-fundador",
    bio: "Lidera la dirección de la compañía y la educación financiera de Finbo. Asesor Financiero registrado ante la CNV.",
    badge: "Asesor CNV",
  },
  {
    name: "Ramiro Rinaldi",
    role: "Staff Engineer · +15 años",
    bio: "Co-fundador de Finbo. Staff Engineer con más de 15 años desarrollando, lideró equipos de ingenieros y aporta la visión técnica del producto.",
  },
  {
    name: "Mario Troiano",
    role: "Founder · +7 años",
    bio: "Co-fundador de Finbo. Con más de 7 años de experiencia, construyó Finbo desde cero: backend, aplicación móvil e infraestructura cloud.",
  },
];

export default function TeamSection() {
  return (
    <section
      id="equipo"
      data-section="section-team"
      className="relative py-24 sm:py-36 border-y border-white/[0.05]"
      aria-label="Equipo de Finbo"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div data-particle-shield className="max-w-3xl mb-14">
          <div className="text-[12px] tracking-[0.2em] uppercase text-white/40 mb-5 inline-flex items-center gap-2">
            <MapPin size={13} className="text-primary" />
            Buenos Aires, 2025
          </div>
          <h2 className="text-[clamp(36px,5.5vw,72px)] font-extrabold leading-[1.05] tracking-tight">
            Detrás de Finbo,{" "}
            <span className="gradient-text">gente real.</span>
          </h2>
          <p className="text-white/55 mt-5 text-base sm:text-lg max-w-2xl leading-relaxed">
            Un equipo argentino que combina experiencia técnica con conocimiento
            del mercado financiero local. Un Asesor Financiero registrado en la
            CNV en la dirección, y dos co-fundadores a cargo del producto, codo
            a codo.
          </p>
        </div>

        <div
          data-particle-shield
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5"
        >
          {TEAM.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 0.7,
                ease: [0.16, 1, 0.3, 1],
                delay: i * 0.06,
              }}
              className="surface-paper rounded-2xl p-7 h-full flex flex-col"
            >
              <div className="flex items-start justify-between gap-3 mb-4">
                <div className="text-[11px] tracking-[0.18em] uppercase text-primary">
                  {m.role}
                </div>
                {m.badge && (
                  <span className="inline-flex items-center gap-1.5 text-[10.5px] tracking-wider uppercase text-primary bg-primary/10 border border-primary/25 rounded-full px-2.5 py-1">
                    <ShieldCheck size={11} />
                    {m.badge}
                  </span>
                )}
              </div>
              <div className="text-white text-xl font-semibold mb-3">
                {m.name}
              </div>
              <p className="text-white/55 leading-relaxed text-[15px]">
                {m.bio}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
